import { translate } from "@/modules/shared/IntlProviderWrapper";

export const SUPPORT_EMAIL = "support@qlector.com";
export const KOLEKTOR_HELP_DESK_URL = "https://servicedesk.kolektor.com/";

export type HelpDeskMailtoContext = {
    username: string;
    userTitle: string;
    orgCode: string;
    appVersion?: string;
    pageUrl: string;
};

/**
 * Builds a mailto href to Qlector support with a prefilled subject and diagnostic body.
 */
export function buildSupportMailtoHref(context: HelpDeskMailtoContext): string {
    const subject = translate("Header.menu.help_desk.email_subject", "Qlector LEAP support request");
    const intro = translate("Header.menu.help_desk.email_body_intro", "Please describe your issue:");
    const userLabel = translate("common.user", "User");
    const orgLabel = translate("Header.menu.organisation", "Organisation");
    const versionLabel = translate("common.version", "Version");
    const pageLabel = translate("common.page", "Page");

    const details: string[] = [];
    const userIdentity = formatUserIdentity(context.userTitle, context.username);
    if (userIdentity) {
        details.push(`${userLabel}: ${userIdentity}`);
    }

    details.push(`${orgLabel}: ${context.orgCode}`);
    if (context.appVersion) {
        details.push(`${versionLabel}: ${context.appVersion}`);
    }

    details.push(`${pageLabel}: ${context.pageUrl}`);

    const body = [intro, "", "", "---", ...details].join("\n");

    return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function formatUserIdentity(userTitle: string, username: string): string {
    if (userTitle && username) {
        return `${userTitle} (${username})`;
    }

    return userTitle || username;
}

/**
 * Kolektor keeps its Service Desk URL; other organisations get a support mailto.
 */
export function getHelpDeskHref(isKolektor: boolean, context: HelpDeskMailtoContext): string {
    if (isKolektor) {
        return KOLEKTOR_HELP_DESK_URL;
    }

    return buildSupportMailtoHref(context);
}
